"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    documentTemplates: {
        path: "/settings/data/document-templates"
    },
    createDocumentTemplate: {
        path: "/settings/data/document-templates/create"
    },
    updateDocumentTemplate: {
        path: "/settings/data/document-templates/update"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvZG9jdW1lbnRUZW1wbGF0ZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGRvY3VtZW50VGVtcGxhdGVzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9kb2N1bWVudC10ZW1wbGF0ZXNcIixcbiAgfSxcbiAgY3JlYXRlRG9jdW1lbnRUZW1wbGF0ZToge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2RhdGEvZG9jdW1lbnQtdGVtcGxhdGVzL2NyZWF0ZVwiLFxuICB9LFxuICB1cGRhdGVEb2N1bWVudFRlbXBsYXRlOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9kb2N1bWVudC10ZW1wbGF0ZXMvdXBkYXRlXCIsXG4gIH0sXG59KTtcbiJdLCJuYW1lcyI6WyJyb3V0ZXMiLCJidWlsZFJvdXRlcyIsImRvY3VtZW50VGVtcGxhdGVzIiwicGF0aCIsImNyZWF0ZURvY3VtZW50VGVtcGxhdGUiLCJ1cGRhdGVEb2N1bWVudFRlbXBsYXRlIl0sIm1hcHBpbmdzIjoiOzs7OytCQUVhQTs7O2VBQUFBOzs7dUJBRmU7QUFFckIsTUFBTUEsU0FBU0MsSUFBQUEsa0JBQVcsRUFBQztJQUNoQ0MsbUJBQW1CO1FBQ2pCQyxNQUFNO0lBQ1I7SUFDQUMsd0JBQXdCO1FBQ3RCRCxNQUFNO0lBQ1I7SUFDQUUsd0JBQXdCO1FBQ3RCRixNQUFNO0lBQ1I7QUFDRiJ9